export const colour = {
  energy: {
    primaryGradientTop: "#0DA00D",
    primaryGradientBottom: "#096E09"
  },
  assisted: {
    primaryGradientTop: "#FFAB00",
    primaryGradientBottom: "#D86500"
  },
  brand: {
    blue: "#00C5FF",
    darkBlue: "#0096D8",
    green: "#0DA00D",
    red: "#D80000",
    orange: "#D86500",
    purple: "#B062D1"
  },
  grey: {
    100: "#1C201C",
    200: "#3E433E",
    300: "#5C625C",
    400: "#838883",
    500: "#DBE1DB",
    600: "#F1F4F1",
    700: "#F8FAF8"
  }
};

export const width = {
  outer: 1280,
  inner: 1280,
  innerNarrow: 600
};

export const font = {
  sansSerif: "Source Sans Pro, sans-serif"
};
